/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerFindAllQueryResponse, UserControllerFindAllQueryParams, UserControllerFindAll401, UserControllerFindAll403 } from "../../models/usersController/UserControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { userControllerFindAll } from "../../clients/usersService/userControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const userControllerFindAllQueryKey = (params: UserControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/users'
}, ...(params ? [params] : [])] as const;
export type UserControllerFindAllQueryKey = ReturnType<typeof userControllerFindAllQueryKey>;
export function userControllerFindAllQueryOptions(params?: UserControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = userControllerFindAllQueryKey(params);
  return queryOptions<UserControllerFindAllQueryResponse, ResponseErrorConfig<UserControllerFindAll401 | UserControllerFindAll403>, UserControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return userControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all users with their roles
 * {@link /api/v1/users}
 */
export function useUserControllerFindAll<TData = UserControllerFindAllQueryResponse, TQueryData = UserControllerFindAllQueryResponse, TQueryKey extends QueryKey = UserControllerFindAllQueryKey>(params?: UserControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<UserControllerFindAllQueryResponse, ResponseErrorConfig<UserControllerFindAll401 | UserControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userControllerFindAllQueryKey(params);
  const query = useQuery({
    ...userControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserControllerFindAll401 | UserControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}